import { sortBy } from "lodash";
import qs from "qs";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { Magazine } from "types";
import Image from "./Image";

type Props = {
  banner: Magazine.BannerItem;
};

export default function BannerCard({ banner }: Props) {
  const album = useMemo(() => {
    return sortBy(banner.album ?? [], (e) => e.displayOrder);
  }, [banner.album]);
  const isSingle = album.length === 1;
  const isMulti = album.length > 1;
  if (isSingle)
    return (
      <Link
        to={{ pathname: "banner-details", search: `bannerId=${banner.id}` }}
        state={banner}
        className="block w-full space-y-2.5 group hover:shadow transition-shadow"
      >
        <article className="w-full grid grid-cols-1 grid-rows-1 aspect-[0.7] overflow-hidden">
          <Image
            src={album.at(0)?.url}
            alt={banner.title}
            className="size-full [grid-area:1/1] object-cover group-hover:scale-110 transition-transform"
          />
          <div className="relative z-10 [grid-area:1/1] self-end py-11 px-[1.125rem] space-y-2.5">
            <h3 className="text-[1.75rem] font-medium text-white empty:hidden">
              {banner.title}
            </h3>
            <p className="text-base font-medium text-white empty:hidden">
              {banner.subTitle}
            </p>
          </div>
        </article>
        <div className="w-full h-2.5 flex items-center col-span-full">
          <hr className="border-[#ECEFF2] w-full" />
        </div>
      </Link>
    );
  if (isMulti)
    return (
      <article className="w-full space-y-2.5 px-5">
        <h3 className="text-base font-medium text-dark">{banner.title}</h3>
        <div className="grid grid-cols-3 gap-2.5">
          {[...Array(4).keys()].map((i) => (
            <Link
              key={i}
              to={{
                pathname: "banner-details",
                search: qs.stringify(
                  { bannerId: banner.id, imageId: album.at(i)?.id ?? null },
                  { skipNulls: true },
                ),
              }}
              state={banner}
              className="block w-full aspect-image first:col-span-full rounded overflow-hidden group hover:shadow transition-shadow"
            >
              <Image
                src={album.at(i)?.url}
                alt={banner.title}
                className="size-full object-cover transition-transform group-hover:scale-110"
              />
            </Link>
          ))}
        </div>
        <div className="w-full h-2.5 flex items-center col-span-full">
          <hr className="border-[#ECEFF2] w-full" />
        </div>
      </article>
    );
  return null;
}
